<template>
  <div class="validation-panel" v-if="totalCount > 0">
    <!-- 待完善内容（必填项） -->
    <div class="panel-section" v-if="errorItems.length">
      <div class="section-header">
        <span>待完善内容(必填项)</span>
        <el-badge :value="errorItems.length" class="item-badge" type="danger" />
      </div>
      <el-link @click="handleGoToFirstError"> 去完善 &gt;&gt; </el-link>
    </div>
    <!-- 建议优化项 -->
    <div class="panel-section" v-if="suggestionItems.length">
      <div class="section-header">
        <span>建议优化项</span>
        <el-badge :value="suggestionItems.length" class="item-badge" type="warning" />
      </div>
      <el-link @click="handleSuggestionClick()"> 去优化 &gt;&gt; </el-link>
    </div>

    <div class="suggestion-details">
      <div
        v-for="(item, index) in productList"
        :key="'suggestion-' + index"
        class="suggestion-detail-item"
        @click="handleSuggestionClick(item)"
      >
        <div class="suggestion-label">{{ item.label }}</div>
        <div class="suggestion-message">{{ item.message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValidationPanel',
  props: {
    errorItems: {
      type: Array,
      default: () => [],
    },
    suggestionItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      clickItem: null,
      clickSuggestAll: false
    };
  },
  computed: {
    totalCount() {
      return this.errorItems.length + this.suggestionItems.length;
    },
    productList() {
      const list = [];
      if (this.clickSuggestAll) {
        list.push(...this.suggestionItems);
      } else if (this.clickItem) {
        list.push(this.clickItem);
      } else {
        const allList = [this.errorItems[0], ...this.suggestionItems].filter(Boolean);
        list.push(allList[0]);
      }
      return list;
    },
  },
  methods: {
    handleGoToFirstError() {
      if (this.errorItems.length > 0) {
        this.scrollItem(this.errorItems[0]);
      }
      this.clickSuggestAll = false;
    },
    handleSuggestionClick(item) {
      if(!item) {
        this.clickSuggestAll = true;
      }
      item = item || this.suggestionItems[0];
      this.scrollItem(item);
    },
    scrollItem(item) {
      this.clickItem = item;
      this.$emit('scroll-to', item);
    },
  },
};
</script>

<style lang="scss">
.validation-panel {
  position: fixed;
  right: 1232px;
  top: 50%;
  transform: translateY(-50%);
  width: 260px;
  max-height: 80vh;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 2000;
  padding: 16px;

  // 抽屉宽 1230px，面板实际占宽 294px（260px + padding + border）。
  // 视口不足以同时容纳二者时，避免面板左侧移出屏幕。
  @media screen and (max-width: 1526px) {
    right: auto;
    left: 0;
  }

  .panel-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-header {
      margin-bottom: 8px;
      .item-badge {
        margin-left: 15px;
        position: relative;
        top: 5px;
      }
    }
  }
  .suggestion-details {
    .suggestion-detail-item {
      padding: 8px 0;
      cursor: pointer;
      border-bottom: 1px dashed #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: #fdf6ec;
        margin: 0 -8px;
        padding-left: 8px;
        padding-right: 8px;
      }

      .suggestion-label {
        font-size: 13px;
        color: #e6a23c;
        font-weight: 500;
        margin-bottom: 4px;
      }

      .suggestion-message {
        font-size: 12px;
        line-height: 1.6;
        color: #909399;
      }
    }
  }
}
</style>
